import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SvgIcon from '../../SvgIcon/SvgIcon';
import { useRoutes } from '../../../hooks/routes/useRoutes';
import useDebounced from '../../../hooks/useDebounced';

const SearchInputField: React.FC = () => {
  const [focused, setFocused] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const { searchAccessibleRoutes, clearRoutes, setIsLoading } = useRoutes();
  const debouncedSearch = useDebounced(searchTerm, 400); // 🕐 retrasa 400 ms la ejecución
  const location = useLocation();

  const isExpanded = focused || searchTerm.trim().length > 0;

  // 🔁 Efecto controlado solo por el valor debounced
  useEffect(() => {
    const term = debouncedSearch.trim();

    if (!term) {
      clearRoutes();
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    searchAccessibleRoutes(term);
  }, [debouncedSearch]);

  // 🧹 Al navegar (por un resultado de búsqueda o por cualquier otro medio),
  // el buscador se limpia solo en vez de quedar con el texto y los
  // resultados de la búsqueda anterior.
  useEffect(() => {
    setSearchTerm('');
    clearRoutes();
    setIsLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <div
      className={`relative flex h-11 items-center
                  bg-stroke dark:bg-strokedark rounded-full shadow-sm transition-all duration-300
                  ease-in-out focus-within:ring-2 focus-within:ring-primary
                  ${isExpanded ? 'w-[22rem]' : 'w-[16rem]'}`}
    >
      {/* 🔍 Icono fijo */}
      <div className="absolute left-4 top-1/2 -translate-y-1/2">
        <SvgIcon
          name="search"
          width={20}
          height={20}
          className="fill-body hover:fill-primary dark:fill-white dark:hover:fill-stroke transition-colors duration-150"
        />
      </div>

      {/* 🧾 Input */}
      <input
        type="text"
        placeholder="Escribe para buscar..."
        value={searchTerm}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="h-full w-full rounded-full bg-transparent pl-12 pr-5
                    text-base font-medium focus:outline-none
                    text-black placeholder-gray-500 dark:text-white dark:placeholder-gray-300"
      />
    </div>
  );
};

export default SearchInputField;
